import { ResaComponent } from './components/sections/resa/resa.component';
import { BarcodeComponent } from './components/sections/barcode/barcode.component';
import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth.guard';
import { BookComponent } from './components/sections/catalogo/book/book.component';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./auth/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'password-recovery',
    loadChildren: () => import('./auth/password-recovery/password-recovery.module').then( m => m.PasswordRecoveryPageModule)
  },
{
  path: 'barcode',
  component : BarcodeComponent
},


  {
    path: ':id',
    loadChildren: () => import('./main/main.module').then( m => m.MainPageModule),
    canActivate: [AuthGuard]
  },  {
    path: '**',
    redirectTo: 'catalogo'
  },
/*   {
    path: 'barcode',
    loadChildren: () => import('./barcode/barcode.module').then( m => m.BarcodePageModule)
  },
 */


];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
